<template>
	<div>
		<div class="row">
			<b-tabs pills v-model="tabIndex">
				<b-tab v-for="(i,idx) in tabList" :key="idx" :title="i.name">
				</b-tab>
				<template #tabs-end>
					<b-nav-item class="filter" role="presentation" 
						@click.prevent="searchFilterButtonClick" href="#"><i class="fas fa-angle-down icon-down"></i><i class="fas fa-angle-up icon-up"></i></b-nav-item>
				</template>
			</b-tabs>
		</div>
        
		<div class="row" style="padding-bottom:20px;">
			<div class="col-md-12 search form minimize"> 			
				<form class="search fuel formsearch" v-on:change="resumePilihan">
					<div class="button_attach_detach" style="float:right;">
						<b-button @click="floatingSearchForm" class="attach detach" variant="light" href="#"><i class="fas fa-angle-right"></i></b-button>
					</div>
					<div class="row">
                        <div class="row col-md-12">
                            <div class="col-md-6">
                                <h6>Bulan</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;"> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;" v-for="(item, index) in this.months" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'month-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangeMonth(item, item.Grup)">
                                        <label class="custom-control-label" :for="'month-checkbox-'+item.Id">{{item.Name}}</label>
                                    </div> 
                                </div>
                            </div>
                            <div class="col-md-6">
                                <ReportParamSelect title="Tahun" name="year" v-model="year" :options="years_select" />
                                <!--
                                <h6>Tahun</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;"> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.years_checkbox" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'year-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangeYear(item, item.Grup)">
                                        <label class="custom-control-label" :for="'year-checkbox-'+item.Id">{{item.Name}}</label>
                                    </div> 
                                </div> -->
                            </div>
                        </div>

                        <div class="row mt-4" v-if="tabIndex==0"> 
                            <div class="col-md-12">
                                <h6>Kategori</h6>
                                <div class="row col-md-12" style="padding-left:20px;">   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-1" v-model="pengeluaran_visibility.pengeluaran">
                                        <label class="custom-control-label" for="checkbox-1">Pengeluaran</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-2" v-model="pengeluaran_visibility.biaya_administrasi_bank">
                                        <label class="custom-control-label" for="checkbox-2">Biaya Administrasi Bank</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-3" v-model="pengeluaran_visibility.pajak_notpool">
                                        <label class="custom-control-label" for="checkbox-3">Pajak NOTPOOL</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-4" v-model="pengeluaran_visibility.pajak_giro">
                                        <label class="custom-control-label" for="checkbox-4">Pajak Giro</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="checkbox-5" v-model="pengeluaran_visibility.bank_charge">
                                        <label class="custom-control-label" for="checkbox-5">Bank Charge</label>
                                    </div>   
                                </div>                                                      
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_visibility.pengeluaran">
                                <h6>Pengeluaran</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.pengeluaran.pengeluaran_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.pengeluaran.pengeluaran_data, item, pengeluaran_label.pengeluaran)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_visibility.biaya_administrasi_bank">
                                <h6>Biaya Administrasi Bank</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.pengeluaran.biaya_administrasi_bank_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.pengeluaran.biaya_administrasi_bank_data, item, pengeluaran_label.biaya_administrasi_bank)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>
                            
                            <div class="col-md-12 mt-4" v-if="pengeluaran_visibility.pajak_notpool">
                                <h6>Pajak NOTPOOL</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.pengeluaran.pajak_notpool_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.pengeluaran.pajak_notpool_data, item, pengeluaran_label.pajak_notpool)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_visibility.pajak_giro">
                                <h6>Pajak Giro</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.pengeluaran.pajak_giro_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.pengeluaran.pajak_giro_data, item, pengeluaran_label.pajak_giro)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_visibility.bank_charge">
                                <h6>Bank Charge</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.pengeluaran.bank_charge_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.pengeluaran.bank_charge_data, item, pengeluaran_label.bank_charge)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                        </div>

                        <div class="row mt-4" v-if="tabIndex==1"> 
                            <div class="col-md-12">
                                <h6>Kategori</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="pengeluaran-persentase-checkbox-1" v-model="pengeluaran_persentase_visibility.pengeluaran">
                                        <label class="custom-control-label" for="pengeluaran-persentase-checkbox-1">Pengeluaran</label>
                                    </div> 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="pengeluaran-persentase-checkbox-6" v-model="pengeluaran_persentase_visibility.pengeluaran_per_bank">
                                        <label class="custom-control-label" for="pengeluaran-persentase-checkbox-6">Pengeluaran Per Bank</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="pengeluaran-persentase-checkbox-2" v-model="pengeluaran_persentase_visibility.biaya_administrasi_bank">
                                        <label class="custom-control-label" for="pengeluaran-persentase-checkbox-2">Biaya Administrasi Bank</label>
                                    </div>   
 
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="pengeluaran-persentase-checkbox-4" v-model="pengeluaran_persentase_visibility.pajak_giro">
                                        <label class="custom-control-label" for="pengeluaran-persentase-checkbox-4">Pajak Giro</label>
                                    </div>   
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
                                        <input type="checkbox" class="custom-control-input" id="pengeluaran-persentase-checkbox-5" v-model="pengeluaran_persentase_visibility.bank_charge">
                                        <label class="custom-control-label" for="pengeluaran-persentase-checkbox-5">Bank Charge</label>
                                    </div>   
                                </div>
                                                        
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_persentase_visibility.pengeluaran">
                                <h6>Pengeluaran</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.persentase_pengeluaran.pengeluaran_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.persentase_pengeluaran.pengeluaran_data, item, persentase_pengeluaran_label.pengeluaran)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_persentase_visibility.pengeluaran_per_bank">
                                <h6>Pengeluaran Per Bank</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.persentase_pengeluaran.pengeluaran_per_bank_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.persentase_pengeluaran.pengeluaran_per_bank_data, item, persentase_pengeluaran_label.pengeluaran_per_bank)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_persentase_visibility.biaya_administrasi_bank">
                                <h6>Biaya Administrasi Bank</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.persentase_pengeluaran.biaya_administrasi_bank_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.persentase_pengeluaran.biaya_administrasi_bank_data, item, persentase_pengeluaran_label.biaya_administrasi_bank)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_persentase_visibility.pajak_giro">
                                <h6>Pajak Giro</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.persentase_pengeluaran.pajak_giro_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.persentase_pengeluaran.pajak_giro_data, item, persentase_pengeluaran_label.pajak_giro)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                            <div class="col-md-12 mt-4" v-if="pengeluaran_persentase_visibility.bank_charge">
                                <h6>Bank Charge</h6>
                                <hr style="margin-top:0px;">
                                <div class="row col-md-12" style="padding-left:20px;">
                                    <div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;"  v-for="(item, index) in this.pengeluaranLabelList(ytd.persentase_pengeluaran.bank_charge_data)" :key="index">
                                        <input type="checkbox" class="custom-control-input" :id="'pengeluaran-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangePengeluaranLabel(ytd.persentase_pengeluaran.bank_charge_data, item, persentase_pengeluaran_label.bank_charge)">
                                        <label class="custom-control-label" :for="'pengeluaran-checkbox-'+item.Id">{{item.NamaPengeluaran}}</label>
                                    </div> 
                                </div>
                            </div>

                        </div>

					</div>
				</form>
			</div> 
		</div> 

        <div class="row" v-if="tabIndex==0"> 
            <div class="col-md-12" v-if="pengeluaran_visibility.pengeluaran">
                <BarCard :title="'A. PENGELUARAN ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.pengeluaran.pengeluaran_data,this.pengeluaran_label.pengeluaran)" :width="500" :height="600" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="pengeluaran_visibility.biaya_administrasi_bank">
                <BarCard :title="'B. BIAYA ADMINISTRASI BANK ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.pengeluaran.biaya_administrasi_bank_data,this.pengeluaran_label.biaya_administrasi_bank)" :width="500" :height="550" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="pengeluaran_visibility.pajak_notpool">
                <BarCard :title="'C. PAJAK NOTPOOL ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.pengeluaran.pajak_notpool_data,this.pengeluaran_label.pajak_notpool)" :width="500" :height="400" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="pengeluaran_visibility.pajak_giro">
                <BarCard :title="'D. PAJAK GIRO ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.pengeluaran.pajak_giro_data,this.pengeluaran_label.pajak_giro)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
            <div class="col-md-12" v-if="pengeluaran_visibility.bank_charge">
                <BarCard :title="'E. BANK CHARGE ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.pengeluaran.bank_charge_data,this.pengeluaran_label.bank_charge)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>
        </div>

        <div class="row" v-if="tabIndex==1">
            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pengeluaran">
                <BarCard :title="'PENGELUARAN ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.persentase_pengeluaran.pengeluaran_data,this.persentase_pengeluaran_label.pengeluaran)" :width="500" :height="600" url="/treasury" id="1"/>
                <Loader v-if="loading.chart"/>
            </div>  

            <!--
            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pengeluaran">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in ytd.piechart_persentase_pengeluaran.pengeluaran" :key="index">

                        <div class="card cardptpr mb-4">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>PENGELUARAN {{ item[0].MonthName.toUpperCase() }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%;">
                                <PieChart :data="pieChartData(item)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            -->
            
            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pengeluaran_per_bank">
                <BarCard :title="'A. PENGELUARAN PER BANK ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.persentase_pengeluaran.pengeluaran_per_bank_data,this.persentase_pengeluaran_label.pengeluaran_per_bank)" :width="500" :height="550" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div> 

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pengeluaran_per_bank">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in pieChartPengeluaran(ytd.piechart_persentase_pengeluaran.pengeluaran_per_bank)" :key="index">
                        
                            <div class="card cardptpr mb-4">
                                <div class="card-header cardptpr p-3 pb-0 pt-0">
                                    <H6>PER BANK {{ item[0].MonthName.toUpperCase() + ' ' + selected_current_year}}</H6>
                                </div>
                                <div class="card-body p-3 pt-0" style="width:100%;">
                                    <PieChart :data="pieChartData(item)"
                                        :url="'/treasury?tab=2&'"/>
                                </div>
                            </div>
                       
                        
                    </div>
                </div>
            </div>
            
            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.biaya_administrasi_bank">
                <BarCard :title="'B. BIAYA ADMINISTRASI BANK ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.persentase_pengeluaran.biaya_administrasi_bank_data,this.persentase_pengeluaran_label.biaya_administrasi_bank)" :width="500" :height="400" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.biaya_administrasi_bank">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in pieChartPengeluaran(ytd.piechart_persentase_pengeluaran.biaya_administrasi_bank)" :key="index">

                        <div class="card cardptpr mb-4" v-if="selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(item[0].Bulan, 0))">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>ADMINISTRASI BANK {{ item[0].MonthName.toUpperCase() + ' ' + selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%;">
                                <PieChart :data="pieChartData(item)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pajak_giro">
                <BarCard :title="'C. PAJAK GIRO ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.persentase_pengeluaran.pajak_giro_data,this.persentase_pengeluaran_label.pajak_giro)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div>   

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.pajak_giro">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in pieChartPengeluaran(ytd.piechart_persentase_pengeluaran.pajak_giro)" :key="index">

                        <div class="card cardptpr mb-4" v-if="selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(item[0].Bulan, 0))">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>PAJAK GIRO {{ item[0].MonthName.toUpperCase() + ' ' + selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%;">
                                <PieChart :data="pieChartData(item)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.bank_charge">
                <BarCard :title="'D. BANK CHARGE ' + selected_current_year" :data="this.barchartPengeluaran(this.ytd.persentase_pengeluaran.bank_charge_data,this.persentase_pengeluaran_label.bank_charge)" :width="500" :height="450" url="/treasury"/>
                <Loader v-if="loading.chart"/>
            </div> 

            <div class="col-md-12" v-if="pengeluaran_persentase_visibility.bank_charge">
                <div class="row">
					<div class="col-md-3" v-for="(item, index) in pieChartPengeluaran(ytd.piechart_persentase_pengeluaran.bank_charge)" :key="index">

                        <div class="card cardptpr mb-4" v-if="selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(item[0].Bulan, 0))">
                            <div class="card-header cardptpr p-3 pb-0 pt-0">
                                <H6>BANK CHARGE {{ item[0].MonthName.toUpperCase() + ' ' + selected_current_year }}</H6>
                            </div>
                            <div class="card-body p-3 pt-0" style="width:100%;">
                                <PieChart :data="pieChartData(item)"
                                    :url="'/treasury?tab=2&'"/>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

	</div>
</template>

<script>

//import Cafe from '@/components/page/Cafe.js'

import Treasury from '@/components/page/Treasury.js'
import BarCard from '@/views/pages/BarCard.vue'
import PieChart from '@/components/chart/Pie.js'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'
import { Rainbow, Rainbow3, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable.vue'

export default
{
	extends: Treasury,
	components: { 
		BarCard,
		PieChart,
		Loader,
        ReportParamSelect,
	},

	data(){
		return {
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "INACTIVE" }, 
				],
			},
            monthNames: ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
            months: [],
            years_local:[],
			tabList:[
				{name:'Pengeluaran'},
                {name:'Persentase Pengeluaran'},
			],
            pengeluaran_visibility: { 
                pengeluaran: true, 
                biaya_administrasi_bank: true, 
                pajak_notpool: true, 
                pajak_giro: true, 
                bank_charge: true, 
            },
            pengeluaran_persentase_visibility: { 
                pengeluaran: true, 
                pengeluaran_per_bank: true, 
                biaya_administrasi_bank: true, 
                pajak_giro: true, 
                bank_charge: true, 
            },
            selected_months: [],
            selected_years: [],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,  
			area: this.$route.query.area ? this.$route.query.area : '',
			status: this.$route.query.status ? this.$route.query.status : '',
            year: this.$route.query.year ? this.$route.query.year : '',
			showmap:false,

			reportdata:[],
		}
	},

    watch: {
        year() { this.loadData(this.year); },
    },
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadData();
        this.loadYears();
        this.loadMonths();
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},

        resumePilihan(){
        },
        /*
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/cafe/cafelist?'

			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&status='+this.status

			this.loading.table = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
				})
				.catch(error => {
					//console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        */
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

        pieChartData(item)
        {
                var warna=[];
                let value = [];
                let idx = 0;
                for (var row in item) {
                    //add color
                    warna[item[row].NamaPengeluaran] = Rainbow[idx];//'#FFB22E'

                    //add value
                    let main = {
                        transtype: item[row].NamaPengeluaran, 
						amount: item[row].Nilai,
                    };

                    value.push(main);
                    idx++;
                }

				return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanData(item)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].NamaPenerimaan] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].NamaPenerimaan, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanCashSummary(data)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in data) {
                
                for(var row2 in data[row]) {
                    //console.log("row2: " + data[row][row2])
                    if(row2 == 0) {
                        //add color
                        warna[data[row][row2].MonthName] = Rainbow[idx]; //'#FFB22E'

                        //add value
                        let main = {
                            transtype: data[row][row2].MonthName, 
                            amount: data[row][row2].Nilai,
                        };

                        value.push(main);
                    }
                }              
                idx++;

            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pengeluaranLabelList(data) {
            //console.log("data: "+ JSON.stringify(data));
            let result = []; 
            for (let i in data) {  
                if(result.some(itm => itm.NamaPengeluaran === data[i].NamaPengeluaran)){
                    //console.log("Object found.");
                } else{
                    //console.log("Object not found. ");
                    result.push(data[i]);
                } 
            }
            //console.log("pengeluaranLabelList: " + result);
            //console.log("pengeluaranLabelList called");
            return result;
        },

        handleChangePengeluaranLabel(mainLabelData, data, includeLabels) {
            //console.log("checked: "+ JSON.stringify(data));
            //console.log("checked: " + data.Grup);
            
            if(data.Grup == true) {
                //this.penerimaan_label.penjualan.push(data);
                includeLabels.push(data);
            } else {
                //const index = this.penerimaan_label.penjualan.findIndex(prop => prop.NamaPengeluaran === data.NamaPengeluaran)
                //this.penerimaan_label.penjualan.splice(index,1)

                const index = includeLabels.findIndex(prop => prop.NamaPengeluaran === data.NamaPengeluaran)
                includeLabels.splice(index,1)
            }
            
            //this.barchartPengeluaran(mainLabelData, this.penerimaan_label.penjualan);
            this.barchartPengeluaran(mainLabelData, includeLabels);
        },

        barchartPengeluaran(mainData, includes) {
            //console.log("includes : " + JSON.stringify(includes));
            //console.log("this.selected_months: " + JSON.stringify(this.selected_months) )
            let barchartData = []; //
            //mainData.sort(this.dynamicSort("Bulan"));
            let data = mainData;//this.ytd.penerimaan.penjualan_data;
            for (let i in data) {  
                if(includes.some(itm => itm.NamaPengeluaran === data[i].NamaPengeluaran)) {
                    //console.log("Object found. " + data[i].NamaPengeluaran); 
                    /*
                    for(let z in this.selected_months) {
                        console.log("data[i].Bulan: " + data[i].Bulan + "-" + + this.selected_months[z].Id)
                        //console.log("this.selected_months[z]: " + this.selected_months[z].Id)
                        if(parseInt(data[i].Bulan, 0) === parseInt(this.selected_months[z].Id, 0)) {
                            console.log("found data[i].Bulan: " + data[i].Bulan)
                            barchartData.push(data[i]); 
                        }
                             
                    } */
                    
                    if(this.selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[i].Bulan, 0)) && this.selected_years.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[i].Tahun, 0))) {
                        //console.log("month found "+ data[i].Bulan);
                        barchartData.push(data[i]); 
                    } else {
                        //console.log("month not found " + data[i].Bulan);
                    }
                    //barchartData.push(data[i]);             
                   
                } else{
                    //console.log("Object not found. "+ data[i].NamaPengeluaran);
                    
                } 
            }
            return this.processBarChart(barchartData, "NamaPengeluaran", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true);
        },

        loadMonths() {
            for (var i = 0; i <= 11; i++) {
                //console.log("month: " + i);
                let month = { Id: i+1, Name: this.monthNames[i],Grup: 1}
                this.months.push(month);
                this.selected_months.push(month);
            } 
        },
        loadYears() {
            for (var i = 2015; i <= new Date().getFullYear(); i++) {
                let year = {Id: i, Name: i,Grup: 1}
                this.years_local.push(year);
                this.selected_years.push(year);
            }   
        },

        handleChangeMonth(month, isChecked) {
            //console.log("month: " + month.Name +"-"+isChecked);
            if(isChecked == true) {
                this.selected_months.push(month);
            } else {
                const index = this.selected_months.findIndex(prop => prop.Id === month.Id)
                this.selected_months.splice(index,1)
            }
        },

        handleChangeYear(year, isChecked) {
            //console.log("year: " + year.Name +"-"+isChecked);
            if(isChecked == true) {
                this.selected_years.push(year);
            } else {
                const index = this.selected_years.findIndex(prop => prop.Id === year.Id)
                this.selected_years.splice(index,1)
            }
        },

        pieChartPengeluaran(data) {
            //console.log('pieChartPengeluaran: '+JSON.stringify(data))
            let arrayOfArrays = data
            let pie = [];

            // Check if the outer array is empty or if every inner array is empty
            const isCompletelyEmpty = arrayOfArrays.length === 0 || arrayOfArrays.every(innerArray => innerArray.length === 0);

            /*
            const isCompletelyEmpty = 
                arrayOfArrays === undefined ||  // Check if arrayOfArrays is undefined
                arrayOfArrays.length === 0 ||   // Check if arrayOfArrays is an empty array
                arrayOfArrays.every(innerArray => innerArray.length === 0); 
            */

            if (!isCompletelyEmpty) {
                for(let item in data) {
                    //console.log('item: '+JSON.stringify(item))
                    if(this.selected_months.some(itm2 => parseInt(itm2.Id, 0) === parseInt(data[item][0].Bulan, 0))) {
                        pie.push(data[item]);
                    }
                }
            }

            return pie;
        },

        

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.checkbox-style {
    margin-top: -10px;
}

.checkbox-md .custom-control-label::before, 
.checkbox-md .custom-control-label::after {
  top: .4rem;
  width: 1.2rem;
  height: 1.2rem;
}

.checkbox-md .custom-control-label {
  padding-top: 8px;
  padding-left: 4px;
}

.checkbox-lg .custom-control-label::before, 
.checkbox-lg .custom-control-label::after {
  top: .8rem;
  width: 1.55rem;
  height: 1.55rem;
}

.checkbox-lg .custom-control-label {
  padding-top: 13px;
  padding-left: 6px;
}


.checkbox-xl .custom-control-label::before, 
.checkbox-xl .custom-control-label::after {
  top: 1.2rem;
  width: 1.85rem;
  height: 1.85rem;
}

.checkbox-xl .custom-control-label {
  padding-top: 23px;
  padding-left: 10px;
}

.col-pg {
    flex: 1 0 25%;
}

</style>